import { Navigate } from "react-router-dom";

export function ACL({ showFor, hideFor, redirectTo, children }) {
  const user = JSON.parse(localStorage.getItem("user"));
  if (redirectTo) {
    return showFor?.includes(user?.role) ||
      (hideFor && !hideFor.includes(user?.role)) ? (
      children
    ) : (
      <Navigate to={redirectTo} />
    );
  }
  return (
    (showFor?.includes(user?.role) ||
      (hideFor && !hideFor.includes(user?.role))) &&
    children
  );
}
